const UTILS = require("../libs/utils.js");
var vA740 = ["Double Kill", "Triple Kill", "Quad Kill", "Multi Kill", "Mega Kill", "Ultra Kill", "Super Kill"];
var vA741 = [];
var vA742 = [];
module.exports.reward = function (p16538, p16539, p16540, p16541, p16542) {
  vA741.length = 0;
  vA742.length = 0;
  var v13398 = p16539.weapon;
  if (p16541 && p16541.wId != null) {
    v13398 = p16542.weaponConfig[p16541.wId];
  }
  var v13399 = p16541 && p16541.stk != null;
  if (p16542.mode.weaponOrder && !v13399) {
    if (v13398.melee) {
      p16542.incMedal("Humiliation", p16539);
      vA741.push(0, null, 0, 1);
    } else {
      p16542.incMedal("Promotion", p16539);
      vA741.push(1, null, 0, 1);
    }
  }
  if (p16542.kills <= 1) {
    p16542.incMedal("First Blood", p16539);
    vA741.push(2, 25, 0, 1);
    p16539.firstblood++;
    vA742.push("fb", 1);
  }
  if (p16539.lastKiller && p16540 && p16540.id == p16539.lastKiller) {
    p16539.lastKiller = null;
    p16542.incMedal("Revenge", p16539);
    vA741.push(3, 25, 0, 1);
    p16539.revengeKills++;
    vA742.push("rk", 1);
  }
  if (v13398.melee) {
    if (p16541 && p16541.pj) {
      p16542.incMedal("Bullseye", p16539);
      vA741.push(4, 150, 0, 1);
    } else if (p16541 && p16541.fs) {
      p16542.incMedal("Beatdown", p16539);
      vA741.push(5, 175, 0, 1);
    } else {
      p16542.incMedal("Execution", p16539);
      vA741.push(6, 150, 0, 1);
    }
    if (p16541 && p16541.hs) {
      p16542.incMedal("Headshot", p16539);
      vA741.push(9, 25, 0, 1);
    }
  } else {
    if (v13398.kill) {
      vA741.push(v13398.kill[0], v13398.kill[1], 0, 1);
    } else if (v13398.scope && p16539.aimVal == 1) {
      p16542.incMedal("No Scope", p16539);
      vA741.push(7, 100, 0, 1);
      p16539.noscopes++;
      vA742.push("ns", 1);
    } else if (!v13398.scope || p16539.aimVal == 0 && p16539.aimTime > 180 || p16539.aimDir == 1) {
      vA741.push("", 50, 0, 1);
    } else {
      p16542.incMedal("Quick Scope", p16539);
      vA741.push(8, 75, 0, 1);
      p16539.quickscopes++;
      vA742.push("qs", 1);
    }
    if (p16541 && p16541.hs) {
      p16542.incMedal("Headshot", p16539);
      vA741.push(9, 50, 0, 1);
    }
    if (p16541 && p16541.wb) {
      p16542.incMedal("Wallbang", p16539);
      vA741.push(10, 25, 0, 1);
    }
    if (p16541 && p16541.dst * v13398.range > 200) {
      p16542.incMedal("Longshot", p16539);
      vA741.push(11, 25, 0, 1);
      p16539.longshots++;
      vA742.push("lns", 1);
    }
  }
  if (p16540.flag) {
    p16542.incMedal("Snatched", p16539);
    vA741.push(12, 50, 0, 1);
  }
  if (p16539.health <= p16539.maxHealth * 0.2 && p16539.active) {
    p16542.incMedal("Close Call", p16539);
    vA741.push(13, 20, 0, 1);
    p16539.closecalls++;
    vA742.push("cc", 1);
  }
  if (p16539.deathStreak >= 3) {
    p16542.incMedal("Comeback", p16539);
    vA741.push(14, 25, 0, 1);
  }
  if (p16540.killStreak >= 5) {
    p16542.incMedal("Buzzkill", p16539);
    vA741.push(15, p16540.killStreak >= 10 ? 25 : 10, 0, 1);
    vA742.push("bzk", 1);
  }
  if (p16539.slideTimer > 0) {
    p16542.incMedal("Driftkill", p16539);
    vA741.push(16, 50, 0, 1);
    p16539.driftkills++;
    vA742.push("drk", 1);
  }
  if (p16539.airTime >= 400) {
    p16542.incMedal("Mid Air", p16539);
    vA741.push(17, 25, 0, 1);
    p16539.airKills++;
    vA742.push("airk", 1);
  }
  if (UTILS && UTILS.getD3D(0, 0, 0, p16539.velocity.x, p16539.velocity.y, p16539.velocity.z) * 1000 >= 180) {
    p16542.incMedal("Turbo Kill", p16539);
    p16539.turboKills++;
    vA741.push(18, 25, 0, 1);
    vA742.push("tk", 1);
  }
  for (var v13400 = vA740.length - 1; v13400 >= 0; --v13400) {
    if (p16539.streak > v13400) {
      p16542.incMedal(vA740[v13400], p16539);
      vA741.push(32 + v13400, (v13400 + 1) * 50, 0, 1);
      break;
    }
  }
  if (vA742.length) {
    p16542.challenges.updateMulti(p16542, vA742, {
      wep: p16541 ? p16541.wId : undefined
    }, p16539);
  }
  if (vA741.length) {
    return vA741;
  } else {
    return null;
  }
};
module.exports.getScore = function (p16543) {
  var v13401 = null;
  if (p16543) {
    for (var vLN1169 = 1; vLN1169 < p16543.length; vLN1169 += 4) {
      if (p16543[vLN1169]) {
        v13401 += p16543[vLN1169];
      }
    }
  }
  return v13401;
};